import React from 'react';
import ResetPasswordForm from 'modules/ResetPassword/components/ResetPasswordForm';

const ResetPassword: React.FC = (): JSX.Element => {
  return <ResetPasswordForm />;
};

export default ResetPassword;
